import React from 'react';
import { Rss } from 'lucide-react';

export function EmptyFeed() {
  return (
    <div data-testid="empty-feed" className="brutalist-card text-center py-16">
      <Rss strokeWidth={2.5} size={48} className="mx-auto text-zinc-300 mb-4" />
      <h3 className="text-xl font-bold uppercase mb-2">No entries yet</h3>
      <p className="text-sm text-zinc-500 font-medium max-w-sm mx-auto">
        Add some RSS feed sources from the sidebar to start seeing content here.
      </p>
    </div>
  );
}
